import { writable } from 'svelte/store';

export const st_login  = writable({user:"forbidden", pwd:"", level:0, key:""});